import React, { useState } from 'react';
import Loading from '@ali/infinite-webui/es/web-components/Loading';
import Banner from '../Banner/index-pc';
import Content from '../Content/index-pc';
import Button from '../Button/index-pc';
import Toast from '@ali/infinite-webui/es/web-components/Toast';
import { ShowConfig } from '../../index-pc';
import { cls } from '../../utils';
import { subscribe } from '../../server';
import SubscribePopup, { POPUP_TYPE } from '../../index-pc';
import Styles from './index-pc.module.scss';

const LoadingEle: any = Loading.Element;

function Container(
  props: ShowConfig,
  ref?: React.MutableRefObject<HTMLDivElement>
) {
  const { data, userTrack } = props;
  const { spmc, clickArgs, exposeArgs, spmd } = userTrack || {};
  const {
    title,
    explanation,
    headerImageUrl,
    backgroundColor,
    closeImageUrl,
    indication,
    email,
    targetUrl,
    type,
    subscribeParam,
    successToast,
    failureToast,
    btnText,
    closeBtnText,
    tc,
    imageUrl,
  } = data || {};

  const [loading, setLoading] = useState(false);

  const btnClick = async () => {
    setLoading(true);
    if (type === 'SUBSCRIPTION' && email) {
      const res = await subscribe(subscribeParam);
      if (res && res.data.status === 1) {
        Toast.show(successToast);
        SubscribePopup.close();
      } else {
        Toast.show(failureToast);
      }
    } else if (targetUrl && !email) {
      window.location.href = targetUrl;
    }
    setLoading(false);
  };

  return (
    <div className={Styles.wrap} data-spm={spmc}>
      <div
        className={Styles.container}
        ref={ref}
        style={{
          backgroundColor,
        }}
      >
        <Banner
          url={headerImageUrl}
          title={title}
          closeImageUrl={closeImageUrl}
        />
        <div
          className={cls([
            Styles.main,
            type === POPUP_TYPE.PROMOTION_IMAGE && Styles.promotion_image,
          ])}
          data-spm={`d${spmd}`}
          data-params-exp={JSON.stringify(userTrack.exposeArgs)}
          data-params-clk={JSON.stringify(userTrack.clickArgs)}
        >
          <Content
            explanation={explanation}
            indication={indication}
            email={email}
            imageUrl={imageUrl}
          />
        </div>
        <Button
          btnText={btnText}
          closeBtnText={closeBtnText}
          btnClick={btnClick}
          tc={tc}
          type={type}
          userTrack={userTrack}
        />
      </div>
      <LoadingEle visible={loading} mask />
    </div>
  );
}

export default React.forwardRef(Container);
